import Phaser from 'phaser';

/**
 * BootScene: minimal boot. P0A has no external art/audio assets to preload
 * (the turtle is procedural vector geometry), so we simply hand off to the
 * ColoringScene. Kept as a distinct scene to model the real boot lifecycle.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Boot' });
  }

  create(): void {
    this.scene.start('Coloring');
  }
}
